/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface InterpretingServiceRequest {
  serviceId: number;
  rateId: number;
  priceLow: number | null;
  priceHigh: number | null;
}
const InterpretingServiceRequest = {
  create: (initValues?: Partial<InterpretingServiceRequest> | null): InterpretingServiceRequest => {
    const defaults: InterpretingServiceRequest = {
      serviceId: 0,
      rateId: 0,
      priceLow: null,
      priceHigh: null,
    };
    const fixedValues: Partial<InterpretingServiceRequest> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default InterpretingServiceRequest;
